module.exports = new __parcel__URL__("Troubleshooting Article Hover.a6ecd9aa.svg").toString();